import React, { useState } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { FormSecondStep } from "./secondStepForm";
import { StepButton } from "./stepButton";
import { FormFooter } from "./formFooter";
import moment from "moment";
import { trainerVoiceSchema } from "./voiceAddSchema";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../title";
import { useSelector } from "react-redux";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

const EMPTY_SCHEDULE_DAYS = {
  Saturday: [],
  Sunday: [],
  Monday: [],
  Tuesday: [],
  Wednesday: [],
  Thursday: [],
  Friday: [],
};

const scheduleFromValue = (scheduleDays) => {
  if (
    !scheduleDays ||
    Array.isArray(scheduleDays) ||
    typeof scheduleDays !== "object"
  ) {
    return EMPTY_SCHEDULE_DAYS;
  }
  return {
    Saturday: scheduleDays.Saturday || [],
    Sunday: scheduleDays.Sunday || [],
    Monday: scheduleDays.Monday || [],
    Tuesday: scheduleDays.Tuesday || [],
    Wednesday: scheduleDays.Wednesday || [],
    Thursday: scheduleDays.Thursday || [],
    Friday: scheduleDays.Friday || [],
  };
};

// export const MultiStep = () => {
function MultiStep({
  name,
  email,
  phone,
  payRates,
  gender,
  canLive,
  activeStatus,
  handleSubmit,
  trainerAttributes,
  qualifications,
  image,
  scheduleDays,
}) {
  const [step, setStep] = useState(1);
  const { gym } = useSelector((state) => state.gym);
  const submit = (values) => {
    if (saveVoiceDraftEdit(values)) return;
    handleSubmit(values);
    console.log(values, "values");
  };

  // Keep this out of Formik initialValues. enableReinitialize resets the
  // whole form whenever those values change, which cleared name, email, and
  // gender each time the schedule was edited.
  const [dayTimeState, setDayTimeState] = useState(() =>
    scheduleFromValue(
      withVoicePrefill("instructor", { scheduleDays }).scheduleDays
    )
  );

  const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10-20}$/;

  const formSchema1 = trainerVoiceSchema;

  return (
    <>
      <ModalBody>
        <div className="modal-body-content">
          <div className="add-trainer-popup adding-popup bg-white card-panel">
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title={
                    gym.type == "sportClub" ? "Add Coach"  : gym.type == "complex"
                    ? "Add Instructor"
                    : "Add Instructor"
                  }
                  subtitlestyle="ctf-tx-secondary"
                  subtitle={
                    gym.type == "sportClub"
                      ? "Add Info About Coach"
                      : gym.type == "complex"
                      ? "Add Info Instructor"
                      : "Add Info About Instructor"
                  }
                />
              </div>
              <Formik
                enableReinitialize
                initialValues={withVoicePrefill("instructor", {
                  name,
                  email,
                  phone,
                  gender,
                  canLive,
                  activeStatus:activeStatus?activeStatus:"ACTIVE",
                  image,
                  payRates,
                  qualifications,
                  trainerAttributes,
                  dob: moment(new Date()).format("DD/MM/YYYY"),
                  addTrainerAsMember: false,
                  scheduleDays: scheduleFromValue(scheduleDays),
                })}
                onSubmit={submit}
                validationSchema={formSchema1}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  values,
                  setFieldValue,
                }) => (
                  <Form>
                    {/* {renderStep(step, values, errors, touched, setFieldValue)} */}
                    <FormFirstStep
                      dayTimeState={dayTimeState}
                      setDayTimeState={setDayTimeState}
                      errors={errors}
                      touched={touched}
                      values={values}
                      setFieldValue={setFieldValue}
                      isCreate={true}
                    />
                    <StepButton step={step} />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
}
MultiStep.defaultProps = {
  name: "",
  email: "",
  phone: "",
  subscriptionPlan: "",
  startDate: "",
  endDate: "",
  activeStatus: "",
  qualifications: [],
  canLive: true,
  trainerAttributes: [],
  payRates: [],
  handleSubmit: (values) => {},
  edit: false,
  type: "",
  image: "",
  scheduleDays: [],
};

export default MultiStep;
